import React from "react";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Box, IconButton, Typography } from "@mui/material";
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers";
import { Controller, useFormContext } from "react-hook-form";
import { makeStyles } from "tss-react/mui";

import { FormValues } from "../SchedulerPage";

const useStyles = makeStyles()(() => ({
  icon: {
    color: "#7D8797",
    height: 20,
    width: 20,
  },
  error: {
    fontSize: "12px",
    textAlign: "center",
    color: "#963832",
  },
}));

type Props = {
  ruleIndex: number;
  intervalIndex: number;
  onRemove: (intervalIndex: number) => void;
  override?: boolean;
};

const Intervals: React.FC<Props> = ({
  ruleIndex,
  intervalIndex,
  onRemove,
  override = false,
}) => {
  const { classes } = useStyles();
  const formMethods = useFormContext();
  const { control } = formMethods;

  return (
    <Box display="flex" alignItems="center">
      <Controller
        name={
          override
            ? `dateRules[${ruleIndex}].intervals[${intervalIndex}].startTime`
            : `wdayRules[${ruleIndex}].intervals[${intervalIndex}].startTime`
        }
        control={control}
        render={({ field, fieldState: { error } }) => {
          return (
            <MuiTimePicker
              slotProps={{
                textField: {
                  error: !!error,
                },
              }}
              sx={{ marginBottom: 2 }}
              {...field}
            />
          );
        }}
      />
      <Typography variant="body1" sx={{ marginLeft: 2, marginRight: 2 }}>
        -
      </Typography>
      <Controller
        name={
          override
            ? `dateRules[${ruleIndex}].intervals[${intervalIndex}].endTime`
            : `wdayRules[${ruleIndex}].intervals[${intervalIndex}].endTime`
        }
        control={control}
        render={({ field, fieldState: { error } }) => {
          return (
            <MuiTimePicker
              slotProps={{
                textField: {
                  error: !!error,
                  helperText: error?.message,
                },
              }}
              sx={{ marginBottom: 2 }}
              {...field}
            />
          );
        }}
      />
      <IconButton
        sx={{ marginLeft: 2 }}
        onClick={() => {
          onRemove(intervalIndex);
        }}
      >
        <DeleteOutlineIcon className={classes.icon} />
      </IconButton>
    </Box>
  );
};

export default Intervals;
